/* FRØYA GOURMET — froya-lenker.js v1 (31.10.2026)
   «Vis i kart» (.ul-lenke) åpner kartet pålitelig, også på mobil.
   Noe annet på siden avbrøt klikket på lenken; her tar vi klikket først (capture),
   åpner kartet i ny fane, og faller tilbake til samme fane hvis nettleseren blokkerer popup. */
(function () {
  'use strict';
  if (window.__fgLenker) return;
  window.__fgLenker = true;
  window.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('a.ul-lenke') : null;
    if (!a || !a.href) return;
    if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) return;
    e.stopImmediatePropagation();
    e.preventDefault();
    var w = null;
    try { w = window.open(a.href, '_blank'); } catch (x) {}
    if (w) { try { w.opener = null; } catch (x) {} }
    else { window.location.href = a.href; }
  }, true);
})();
